import { Component, Input } from '@angular/core';
import { ElectoralCoalitionColumnDef } from './electoral-coalition.model';
import { ElectoralCoalitionDto } from "@shared/clients/api.generated";

@Component({
  selector: 'valg-dk-electoral-coalition',
  templateUrl: './electoral-coalition.component.html',
})
export class ElectoralCoalitionComponent{
  electoralCoalitionColumnDef = ElectoralCoalitionColumnDef;
  @Input() data: ElectoralCoalitionDto[] = [];
}
